import React from "react";
import { css } from "@emotion/react";
import { StarSvg, PartialStarSvg } from "./PDPReviewSummary";
import cn from "classnames";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const PDPReviewStars: React.FC<{ rating: number; starsTheme: "dark" | "light" }> = ({ rating, starsTheme }) => {
  const stars = Array.from({ length: 5 }, (_, idx) => {
    if (rating >= idx + 1) {
      return <StarSvg key={`full-${idx}`} className="full" />;
    } else if (rating < idx + 1 && rating > idx) {
      return <PartialStarSvg key={`slice-${idx}`} percentage={rating % idx} className="partial" />;
    } else {
      return <StarSvg key={`empty-${idx}`} className="empty" />;
    }
  });

  return (
    <div
      className={cn("u-flex u-gap-0_5", starsTheme === "dark" ? "theme-dark" : "theme-light")}
      css={css`
        &.theme-dark {
          .full {
            color: ${CSS_COLORS.Black};
          }

          .partial {
            color: ${CSS_COLORS.Black};
          }

          .empty {
            color: #d9d9d9;
          }

          .empty-fill {
            fill: #d9d9d9;
          }
        }

        &.theme-light {
          .full {
            color: ${CSS_COLORS.White};
          }

          .partial {
            color: ${CSS_COLORS.White};
          }

          .empty {
            color: #d9d9d9;
          }

          .empty-fill {
            fill: black;
          }
        }
      `}
    >
      {stars}
    </div>
  );
};
